import React from 'react';
import SVGLoader from './SVGLoader';

const defaults = {
  viewboxHeight: 16,
  viewboxWidth: 16,
};

const BinIcon = ({
  viewboxWidth = defaults.viewboxWidth,
  viewboxHeight = defaults.viewboxHeight,
  ...rest
}) => {
  return (
    <SVGLoader
      viewboxHeight={viewboxHeight}
      viewboxWidth={viewboxWidth}
      {...rest}
    >
      <g clipPath="url(#clip0_1220_2448)">
        <path
          d="M15.6664 3.13903C15.6664 0.8257 8.78635 0.759033 7.99968 0.759033C7.21302 0.759033 0.333018 0.8257 0.333018 3.13903C0.326494 3.21667 0.326494 3.29473 0.333018 3.37237C0.906351 7.37237 1.91968 14.039 2.41968 14.759C2.91968 15.479 4.35968 16.759 7.99968 16.759C11.6397 16.759 13.0397 15.5057 13.553 14.759C14.0664 14.0124 15.0664 7.37237 15.6397 3.37237C15.6548 3.29542 15.6637 3.2174 15.6664 3.13903ZM7.99968 2.09237C11.4797 2.09237 13.753 2.71903 14.2664 3.13903C13.753 3.55237 11.4797 4.17903 7.99968 4.17903C4.51968 4.17903 2.24635 3.55237 1.73302 3.13903C2.24635 2.71903 4.51968 2.09237 7.99968 2.09237ZM5.05302 13.5924H4.99968C4.87623 13.5916 4.75731 13.5458 4.66524 13.4636C4.57317 13.3813 4.5143 13.2683 4.49968 13.1457L3.83302 7.1457C3.82601 7.08004 3.83201 7.01364 3.85067 6.9503C3.86933 6.88696 3.90028 6.82791 3.94175 6.77653C3.98323 6.72514 4.03442 6.68243 4.0924 6.65084C4.15039 6.61924 4.21402 6.59937 4.27968 6.59237C4.41229 6.57822 4.54509 6.61733 4.64886 6.7011C4.70024 6.74258 4.74295 6.79377 4.77455 6.85175C4.80615 6.90973 4.82601 6.97337 4.83302 7.03903L5.49968 13.039C5.51107 13.1711 5.47094 13.3024 5.38768 13.4056C5.30443 13.5087 5.18451 13.5756 5.05302 13.5924ZM8.49969 13.4257C8.49969 13.5583 8.44701 13.6855 8.35324 13.7793C8.25947 13.873 8.13229 13.9257 7.99968 13.9257C7.86708 13.9257 7.7399 13.873 7.64613 13.7793C7.55236 13.6855 7.49968 13.5583 7.49968 13.4257V7.4257C7.49968 7.29309 7.55236 7.16592 7.64613 7.07215C7.7399 6.97838 7.86708 6.9257 7.99968 6.9257C8.13229 6.9257 8.25947 6.97838 8.35324 7.07215C8.44701 7.16592 8.49969 7.29309 8.49969 7.4257V13.4257ZM11.4997 13.1457C11.4851 13.2683 11.4262 13.3813 11.3341 13.4636C11.2421 13.5458 11.1231 13.5916 10.9997 13.5924H10.9464C10.8149 13.5756 10.6949 13.5087 10.6117 13.4056C10.5284 13.3024 10.4883 13.1711 10.4997 13.039L11.1664 7.03903C11.1805 6.90642 11.2467 6.78487 11.3505 6.7011C11.4543 6.61733 11.5871 6.57822 11.7197 6.59237C11.8523 6.60651 11.9739 6.67276 12.0576 6.77653C12.1414 6.8803 12.1805 7.01309 12.1664 7.1457L11.4997 13.1457Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1220_2448">
          <rect
            width="16"
            height="16"
            fill="currentColor"
            transform="translate(0 0.759033)"
          />
        </clipPath>
      </defs>
    </SVGLoader>
  );
};

export default BinIcon;
